import { render } from "./DatabaseStoreSelection.vue?vue&type=template&id=273927d0&scoped=true&ts=true"
import script from "./DatabaseStoreSelection.vue?vue&type=script&lang=ts"
export * from "./DatabaseStoreSelection.vue?vue&type=script&lang=ts"

import "./DatabaseStoreSelection.vue?vue&type=style&index=0&id=273927d0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-273927d0"]])

export default __exports__